import { jsx as l } from "react/jsx-runtime";
import { forwardRef as N, useState as F } from "react";
import U from "react-input-mask";
import R from "classnames";
import Z from "../../helpers/nanoid.js";
import j from "../FieldContainer/index.js";
const E = "forma-ui__input__input", g = "forma-ui__input__withIcon", q = "forma-ui__input__readonly", G = "forma-ui__input__secondary", s = {
  input: E,
  withIcon: g,
  readonly: q,
  secondary: G
}, H = 300, $ = N(({
  id: r = Z(8),
  name: h,
  onChange: p,
  onFocus: f,
  onBlur: _,
  onKeyDown: w,
  onPaste: d,
  type: t = "text",
  hidden: b,
  className: I,
  readOnly: n,
  viewStyle: B = "primary",
  maxLength: k = 50,
  value: i,
  required: z,
  meta: o,
  ...C
}, S) => {
  const [c, y] = F(!1), [L, T] = F(!1), x = (u) => {
    f && f(u), y(!0), T(!0);
  }, A = (u) => {
    _ && _(u), T(!1), setTimeout(() => y(!1), H);
  }, M = c && (o == null ? void 0 : o.showClearButton) && !!i;
  return /* @__PURE__ */ l(
    j,
    {
      id: r,
      hidden: b,
      required: z,
      isShowClear: M,
      isShowButtons: c,
      isShowTooltip: L,
      isShowIcon: c || (o == null ? void 0 : o.showIconAlways),
      ...o,
      children: o != null && o.mask ? /* @__PURE__ */ l(
        U,
        {
          ...C,
          id: r,
          name: h,
          type: t,
          value: i,
          onChange: p,
          onFocus: x,
          onBlur: A,
          onKeyDown: w,
          onPaste: d,
          className: R(
            s.input,
            s[B],
            I,
            (o.icon || o.buttons || o.showClearButton) && s.withIcon,
            o.error && "error",
            o.success && "success",
            n && s.readonly
          ),
          readOnly: n,
          maxLength: o != null && o.mask ? void 0 : k,
          inputRef: S,
          mask: o.mask,
          maskChar: null,
          formatChars: {
            9: "[0-9]",
            a: "[A-Za-z]",
            "*": "[A-Za-zА-Яа-я0-9]"
          }
        }
      ) : /* @__PURE__ */ l(
        "input",
        {
          ...C,
          id: r,
          name: h,
          type: t,
          value: i,
          onChange: p,
          onFocus: x,
          onBlur: A,
          onKeyDown: w,
          onPaste: d,
          className: R(
            s.input,
            s[B],
            I,
            ((o == null ? void 0 : o.icon) || (o == null ? void 0 : o.buttons) || (o == null ? void 0 : o.showClearButton)) && s.withIcon,
            (o == null ? void 0 : o.error) && "error",
            (o == null ? void 0 : o.success) && "success",
            n && s.readonly
          ),
          readOnly: n,
          maxLength: o != null && o.mask ? void 0 : k,
          ref: S
        }
      )
    }
  );
});
export {
  $ as default
};
